import DragHandle from "@common/controls/DragHandle/component";
import Icon, { IconAction, type IconActionSize } from "@common/controls/Icon/component";
import { IconType, type WithChildren } from "@common/declarations";
import { SortableElementHOC, type SortableElementHOCAddedProps } from "@common/hocs/dnd";
import classNames from "classnames";
import React from "react";

export type PillowListItemMapProps = Partial<WithChildren> & {
  prepend?: React.ReactElement<any>;
  iconsAppend?: React.ReactElement<any>;
  iconSize?: IconActionSize;
  className?: string;
  label: string | React.ReactElement<any>;
  rightIcons?: any;
  style?: React.CSSProperties;

  deleteDisabledTooltip?: string;
  cannotDelete?: boolean;
  cannotClone?: boolean;

  cloneTitle?: string;
  deleteTitle?: string;
  editTitle?: string;
  restoreTitle?: string;

  isHandleHidden?: boolean;
};

export interface PillowListItemActionProps {
  onClick?: () => void;
  onTitleClick?: () => void;

  onCloneClick?: () => void;
  onDeleteClick?: () => void;
  onEditClick?: (e: React.MouseEvent) => void;
  onRestoreClick?: () => void;
}
export type PillowListItemProps = PillowListItemActionProps & PillowListItemMapProps;

const PillowListItem = React.forwardRef(
  ({ iconSize = 16, ...props }: PillowListItemProps, ref: React.RefObject<HTMLDivElement | null>) => (
    <div
      className={classNames("pillow_item", props.className, {
        cursor_pointer: !!props.onClick
      })}
      onClick={props.onClick}
      ref={ref}
      style={props.style}
    >
      {props.prepend}

      <span className="caption single-line-ellipsis" onClick={props.onTitleClick}>
        {props.label}
      </span>

      {!!props.iconsAppend ? <div className="icons_append">{props.iconsAppend}</div> : null}

      <div className="icons">
        {!!props.onEditClick && (
          <IconAction
            size={iconSize}
            icon={IconType.Pencil}
            onClick={props.onEditClick}
            title={props.editTitle || "Edit"}
          />
        )}
        {!!props.onCloneClick && !props.cannotClone && (
          <IconAction
            size={iconSize}
            icon={IconType.Clone}
            onClick={props.onCloneClick}
            title={props.cloneTitle || "Clone"}
          />
        )}
        {!!props.onDeleteClick && !props.cannotDelete && (
          <IconAction
            size={iconSize}
            icon={IconType.Delete}
            onClick={props.deleteDisabledTooltip ? undefined : props.onDeleteClick}
            title={props.deleteTitle || "Delete"}
            className={classNames({ disabled: !!props.deleteDisabledTooltip })}
            tooltip={props.deleteDisabledTooltip}
          />
        )}
        {!!props.onRestoreClick && (
          <IconAction
            size={iconSize}
            icon={IconType.Undo}
            onClick={props.onRestoreClick}
            title={props.restoreTitle || "Restore"}
          />
        )}

        {props.rightIcons}
      </div>
    </div>
  )
);
export default PillowListItem;

export type PillowListSortableItemProps = PillowListItemProps & {};
export const PillowListSortableItem = SortableElementHOC<PillowListItemProps>(
  ({ handleProps, isHandleHidden, prepend, ...props }: PillowListSortableItemProps & SortableElementHOCAddedProps) => (
    <PillowListItem
      {...props}
      ref={props.setRef}
      prepend={
        <>
          {!isHandleHidden && <DragHandle tag="span" {...handleProps} />}
          {prepend}
        </>
      }
    />
  )
);

type PillowActionItemProps = {
  icon?: string;
  isActive: boolean;
  label: string;
  onClick: () => void;
};
export const PillowActionItem = (props: PillowActionItemProps) => (
  <PillowListItem
    className={classNames("action", { active: props.isActive })}
    prepend={props.icon ? <Icon icon={props.icon} /> : undefined}
    onClick={props.onClick}
    label={props.label}
  />
);
